import { GET_TYPE_PARAMETERS, GET_TYPE_PARAMETERS_SUCCESS, GET_TYPE_PARAMETERS_ERROR} from './actionTypes';

export const getTypeParams = (user, type) => {
    return {
        type: GET_TYPE_PARAMETERS,
        payload: { user, type }
    }
}

export const getTypeParamsSuccess = (params, message) => {
    return {
        type: GET_TYPE_PARAMETERS_SUCCESS,
        payload: {params, message}
    }
}

export const getTypeParamsError = (msg) => {
    return {
        type: GET_TYPE_PARAMETERS_ERROR,
        payload: msg
    }
}
